module.exports = __webpack_public_path__ + "img/monk.4f8b05cc.png";